/* MasalSensin global JS — consolidated from inline scripts in layout/theme.liquid
   Loaded on all pages via defer. Header-height calculations remain inline in theme.liquid
   because they must run before first paint to prevent layout shift. */

/* ==========================================================================
   1. Announcement bar — rotating messages with date-window seasonal gating
   ========================================================================== */
(function(){
  var bar = document.getElementById('ms-announce-bar');
  if (!bar) return;
  // Seasonal messages: hide when target date is past OR still outside the visibility window (days-until > data-window)
  var today = new Date(); today.setHours(0,0,0,0);
  bar.querySelectorAll('.msg[data-target]').forEach(function(m){
    // Parse YYYY-MM-DD as LOCAL date (not UTC) so TZ offset can't push days over window
    var parts = (m.dataset.target || '').split('-');
    var target = new Date(parseInt(parts[0],10), parseInt(parts[1],10)-1, parseInt(parts[2],10));
    var days = Math.round((target - today) / 86400000);
    var windowDays = parseInt(m.dataset.window || '30', 10);
    if (days <= 0 || days > windowDays) {
      m.parentNode.removeChild(m);
    } else {
      var slot = m.querySelector('.ms-days');
      if (slot) slot.textContent = days;
    }
  });
  var msgs = bar.querySelectorAll('.msg');
  if (!msgs.length) { bar.style.display = 'none'; return; }
  var i = 0;
  msgs[0].classList.add('active');
  bar.style.background = msgs[0].dataset.bg;
  bar.style.color = msgs[0].dataset.color;
  if (msgs.length > 1) {
    setInterval(function(){
      msgs[i].classList.remove('active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('active');
      bar.style.background = msgs[i].dataset.bg;
      bar.style.color = msgs[i].dataset.color;
    }, 4000);
  }
})();

/* ==========================================================================
   2. Product card gallery touchend reset
   ========================================================================== */
(function(){
  document.addEventListener('touchend', function(e){
    var gallery = e.target.closest('card-gallery');
    if (!gallery) return;
    setTimeout(function(){
      var pc = gallery.closest('product-card');
      if (pc && pc.resetImage) {
        pc.resetImage({pointerType: 'mouse'});
      } else {
        var sw = gallery.querySelector('slideshow-component');
        if (sw && sw.previous) sw.previous(undefined, {animate: false});
      }
    }, 700);
  }, {passive: true});
})();

/* ==========================================================================
   3. Product carousel autoplay (Çok Satanlar + featured)
   ========================================================================== */
(function(){
  function initProductListAutoplay() {
    document.querySelectorAll('.product-list slideshow-component, [data-section-type="product-list"] slideshow-component').forEach(function(sw){
      if(sw._autoplay) return;
      sw._autoplay = true;
      var timer = setInterval(function(){
        if(sw.next) sw.next(undefined, {animate: true});
      }, 3500);
      sw.addEventListener('mouseenter', function(){ clearInterval(timer); });
      sw.addEventListener('mouseleave', function(){
        timer = setInterval(function(){ if(sw.next) sw.next(undefined, {animate: true}); }, 3500);
      });
    });
    document.querySelectorAll('slideshow-component').forEach(function(sw){
      if(sw._autoplay) return;
      var section = sw.closest('[id*="en_sevilenler"], [id*="carousel"]');
      if(!section) return;
      sw._autoplay = true;
      setInterval(function(){
        if(sw.next) sw.next(undefined, {animate: true});
      }, 3500);
    });
  }
  setTimeout(initProductListAutoplay, 1000);
  document.addEventListener('DOMContentLoaded', function(){ setTimeout(initProductListAutoplay, 1000); });
})();

/* ==========================================================================
   4. Product card touch-glow
   ========================================================================== */
(function(){
  function initTouchGlow() {
    document.querySelectorAll('product-card').forEach(function(card) {
      if (card.dataset.msTouch) return;
      card.dataset.msTouch = '1';
      var content = card.querySelector('.product-card__content');
      if (!content) return;
      card.addEventListener('touchstart', function() { content.classList.add('ms-touched'); }, {passive:true});
      card.addEventListener('touchend', function() { setTimeout(function(){ content.classList.remove('ms-touched'); }, 150); }, {passive:true});
      card.addEventListener('touchcancel', function() { content.classList.remove('ms-touched'); }, {passive:true});
      card.addEventListener('mouseenter', function() { content.classList.add('ms-touched'); });
      card.addEventListener('mouseleave', function() { content.classList.remove('ms-touched'); });
    });
  }
  function boot(){
    initTouchGlow();
    new MutationObserver(function() { initTouchGlow(); }).observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ==========================================================================
   5. Welcome popup (first-visit discount modal)
   ========================================================================== */
(function(){
  if(localStorage.getItem('ms_popup_seen')) return;
  var show = function(){
    var el = document.getElementById('ms-popup-overlay');
    if (!el) return;
    el.classList.add('show');
    localStorage.setItem('ms_popup_seen','1');
  };
  setTimeout(show, 3000);
})();
/* 13 Oct 2026: the popup used to only close on "Kaydet" and never saved the email.
   It now posts Shopify's native customer (newsletter) form and shows the result. */
function msPopupSubmit(){ var f=document.getElementById('ms-popup-form'); if(f&&f.requestSubmit) f.requestSubmit(); }
(function(){
  function boot(){
    var form=document.getElementById('ms-popup-form'); if(!form) return;
    var msg=document.getElementById('ms-popup-msg');
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=form.querySelector('button[type=submit]'); btn.disabled=true; msg.style.color=''; msg.textContent='';
      fetch(form.action,{method:'POST',body:new FormData(form),headers:{'Accept':'text/html'}})
        .then(function(r){
          if(r.ok&&(/customer_posted=true/.test(r.url)||r.redirected)){
            msg.style.color='#4f8f60'; msg.textContent='Teşekkürler! Listeye eklendiniz.';
            setTimeout(function(){ document.getElementById('ms-popup-overlay').classList.remove('show'); },1600);
          } else if(/challenge/.test(r.url)){ form.submit(); }
          else { throw new Error(r.status); }
        })
        .catch(function(){ msg.style.color='#b5341a'; msg.textContent='Kaydedilemedi, lütfen tekrar deneyin.'; btn.disabled=false; });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();

/* ==========================================================================
   6. "How it works" section — touch feedback on step cards
   ========================================================================== */
(function(){
  function boot(){
    var section = document.querySelector('[id*="ms_how_it_works"]');
    if(!section) return;
    var cards = section.querySelectorAll('.line-card, [class*="step"], [class*="card"]');
    cards.forEach(function(card){
      card.addEventListener('touchstart',function(){ this.classList.add('ms-hw-touched'); },{passive:true});
      card.addEventListener('touchend',function(){
        var el = this;
        setTimeout(function(){ el.classList.remove('ms-hw-touched'); }, 300);
      },{passive:true});
      card.addEventListener('touchcancel',function(){
        var el = this;
        setTimeout(function(){ el.classList.remove('ms-hw-touched'); }, 300);
      },{passive:true});
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ==========================================================================
   7. Cart sticky bar — live smooth update on cart changes (no page reload)
   Sticky bar is server-rendered once via {{ cart.total_price }} in theme.liquid.
   When user adds/removes/changes quantity via Dwell's AJAX cart, we re-fetch
   /cart.js (fast JSON, rarely cached) and update the sticky bar's price spans
   in place. No page reload. Multiple detection strategies ensure we catch the
   mutation regardless of whether Dwell uses fetch, XHR, or internal events.
   ========================================================================== */
(function(){
  var onCartPage = document.body.dataset.template === 'cart' ||
                   !!document.querySelector('main[data-template="cart"]');
  if (!onCartPage) return;

  // Format cents → Shopify-like money string (matches money_without_trailing_zeros)
  // - 99000 → "990TL"
  // - 94050 → "940.50TL"
  // - 159000 → "1,590TL"
  // - 148007 → "1,480.07TL"
  function formatTL(cents) {
    var hasFraction = cents % 100 !== 0;
    var value = cents / 100;
    var parts;
    if (hasFraction) {
      parts = value.toFixed(2).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1] + 'TL';
    }
    return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'TL';
  }

  // Cached cart state for optimistic updates (re-synced after every real response)
  var cachedCart = null;
  function primeCache() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(c){ cachedCart = c; })
      .catch(function(){});
  }
  primeCache();

  // Apply a cart JSON object directly to the sticky bar DOM (no fetch, instant)
  function updateStickyFromCart(cart) {
    var sticky = document.getElementById('ms-cart-sticky');
    if (!sticky || !cart) return;

    if (cart.item_count === 0) {
      sticky.style.display = 'none';
      return;
    }
    sticky.style.display = '';

    var priceEl = sticky.querySelector('.ms-cart-sticky-price');
    var oldEl = sticky.querySelector('.ms-cart-sticky-price-old');

    if (priceEl) priceEl.textContent = formatTL(cart.total_price);

    var originalTotal = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var compareAt = item.variant_compare_at_price || item.compare_at_price || 0;
      if (compareAt && compareAt > item.price) {
        originalTotal += compareAt * item.quantity;
      } else {
        originalTotal += item.original_line_price;
      }
    }

    if (originalTotal > cart.total_price) {
      if (oldEl) {
        oldEl.textContent = formatTL(originalTotal);
        oldEl.style.display = '';
      } else {
        var container = sticky.querySelector('.ms-cart-sticky-prices');
        if (container && priceEl) {
          var newOld = document.createElement('span');
          newOld.className = 'ms-cart-sticky-price-old';
          newOld.textContent = formatTL(originalTotal);
          container.insertBefore(newOld, priceEl);
        }
      }
    } else if (oldEl) {
      oldEl.style.display = 'none';
    }
    // Re-sync cache
    cachedCart = cart;
  }

  // Optimistic: compute predicted total instantly on click, before Dwell's fetch lands
  function optimisticUpdate(row, action) {
    if (!cachedCart || !row) return;
    var key = row.getAttribute('data-key');
    if (!key) return;
    var item = cachedCart.items.find(function(i){ return i.key === key; });
    if (!item) return;

    var delta = 0;
    if (action === 'plus')       delta = item.price;                    // add 1 unit at its price
    else if (action === 'minus') delta = -item.price;                   // remove 1 unit
    else if (action === 'remove')delta = -item.final_line_price;        // remove entire line
    else return;

    var newTotal = Math.max(0, cachedCart.total_price + delta);
    var sticky = document.getElementById('ms-cart-sticky');
    if (!sticky) return;

    if (newTotal === 0) {
      sticky.style.display = 'none';
      return;
    }
    var priceEl = sticky.querySelector('.ms-cart-sticky-price');
    if (priceEl) priceEl.textContent = formatTL(newTotal);

    // Proportionally scale the old (strike-through) price too so it stays in sync optically
    var oldEl = sticky.querySelector('.ms-cart-sticky-price-old');
    if (oldEl && cachedCart.total_price > 0) {
      var ratio = newTotal / cachedCart.total_price;
      // Compute original total from cached cart items
      var origCached = 0;
      for (var i = 0; i < cachedCart.items.length; i++) {
        var it = cachedCart.items[i];
        var ca = it.variant_compare_at_price || it.compare_at_price || 0;
        origCached += (ca && ca > it.price) ? ca * it.quantity : it.original_line_price;
      }
      if (origCached > 0) {
        oldEl.textContent = formatTL(Math.round(origCached * ratio));
      }
    }
  }

  // Fallback: fetch /cart.js when we can't capture the response directly
  var fallbackPending = false;
  function refreshStickyFallback() {
    if (fallbackPending) return;
    fallbackPending = true;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(cart){ updateStickyFromCart(cart); fallbackPending = false; })
      .catch(function(){ fallbackPending = false; });
  }

  // Strategy 1: fetch monkey-patch — DIRECTLY read the response body (no 2nd fetch)
  var origFetch = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    var isCartMutation = typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
    var p = origFetch.apply(this, arguments);
    if (isCartMutation) {
      p.then(function(res){
        if (res && res.ok) {
          // Clone so the original caller can still read the body
          res.clone().json().then(function(cart){
            if (cart && typeof cart.item_count !== 'undefined') {
              updateStickyFromCart(cart);  // Instant — uses Dwell's own response
            } else {
              refreshStickyFallback();
            }
          }).catch(refreshStickyFallback);
        }
      }).catch(function(){});
    }
    return p;
  };

  // Strategy 2: XHR monkey-patch — also read responseText directly
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      var xhr = this;
      xhr.addEventListener('loadend', function(){
        if (xhr.status >= 200 && xhr.status < 400) {
          try {
            var cart = JSON.parse(xhr.responseText);
            if (cart && typeof cart.item_count !== 'undefined') {
              updateStickyFromCart(cart);
            } else {
              refreshStickyFallback();
            }
          } catch (e) {
            refreshStickyFallback();
          }
        }
      });
    }
    return origOpen.apply(this, arguments);
  };

  // Strategy 3: Shopify-dispatched cart events (fallback fetch)
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart-item:removed', 'cart-item:updated'].forEach(function(evt){
    document.addEventListener(evt, refreshStickyFallback);
  });

  // Strategy 4: click listener — OPTIMISTIC update (instant, pre-fetch)
  document.addEventListener('click', function(e) {
    var plus   = e.target.closest('button[name="plus"], .quantity-plus');
    var minus  = e.target.closest('button[name="minus"], .quantity-minus');
    var remove = e.target.closest('.cart-items__remove, button[name="remove"]');
    var action = plus ? 'plus' : (minus ? 'minus' : (remove ? 'remove' : null));
    if (!action) return;
    var row = (plus || minus || remove).closest('[data-key]');
    if (!row) return;
    optimisticUpdate(row, action);
    // The real fetch will arrive shortly after and updateStickyFromCart() will sync the authoritative state
  }, true);
})();

/* ==========================================================================
   8. Homepage bottom navigation bar — cart badge + active state + layout fixes
   ========================================================================== */
(function(){
  var nav = document.getElementById('ms-bottom-nav');
  if (!nav) return;

  // Add padding to body so content doesn't get hidden behind nav
  document.body.style.paddingBottom = '90px';

  // Shift WhatsApp floating button up so it doesn't overlap the nav
  var wa = document.getElementById('ms-whatsapp-btn');
  if (wa) wa.classList.add('ms-shifted-for-nav');

  // Mark active item based on current URL
  (function markActive(){
    var p = location.pathname;
    var items = nav.querySelectorAll('.ms-bn-item');
    items.forEach(function(item){
      var key = item.dataset.nav;
      var match = false;
      if (key === 'home' && (p === '/' || p === '')) match = true;
      else if (key === 'shop' && p.indexOf('/collections') === 0) match = true;
      else if (key === 'gift' && p.indexOf('/pages/hediye-secici') === 0) match = true;
      else if (key === 'cart' && p.indexOf('/cart') === 0) match = true;
      if (match) item.classList.add('active');
    });
  })();

  // Cart badge — update on any cart change (monkey-patches fetch + XHR already above, but we
  // listen to the same events here to sync the bottom nav badge too)
  function updateCartBadge(count){
    var badge = document.getElementById('ms-bn-cart-badge');
    if (!badge) return;
    var n = parseInt(count, 10) || 0;
    badge.textContent = String(n);
    badge.style.display = n > 0 ? '' : 'none';
  }

  function refreshBadgeFromCart(){
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(c){ updateCartBadge(c.item_count); })
      .catch(function(){});
  }

  // Hook into the same fetch/XHR monkey-patches that handle sticky refresh.
  // The existing patches in module 7 already catch cart mutations, so we
  // piggyback by also listening for them here (fire after a small delay to
  // let the backend settle).
  var origFetch2 = window.fetch;
  window.fetch = function(){
    var url = arguments[0];
    var isCartMutation = typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
    var p = origFetch2.apply(this, arguments);
    if (isCartMutation) {
      p.then(function(res){
        if (res && res.ok) {
          res.clone().json().then(function(cart){
            if (cart && typeof cart.item_count !== 'undefined') {
              updateCartBadge(cart.item_count);
            } else {
              setTimeout(refreshBadgeFromCart, 200);
            }
          }).catch(function(){ setTimeout(refreshBadgeFromCart, 200); });
        }
      }).catch(function(){});
    }
    return p;
  };
})();

/* ==========================================================================
   9. Draggable WhatsApp button (edge snap + tap → open chat)
   ========================================================================== */
(function(){
  function init(){
    var btn=document.getElementById('ms-whatsapp-btn');
    if(!btn)return;
    var isDrag=false,startX,startY,startLeft,startTop,moved=false;
    function onStart(e){
      isDrag=true;moved=false;
      var t=e.touches?e.touches[0]:e;
      var rect=btn.getBoundingClientRect();
      startX=t.clientX;startY=t.clientY;
      startLeft=rect.left;startTop=rect.top;
      btn.style.transition='none';
      e.preventDefault();
    }
    function onMove(e){
      if(!isDrag)return;
      var t=e.touches?e.touches[0]:e;
      var dx=t.clientX-startX,dy=t.clientY-startY;
      if(Math.abs(dx)>5||Math.abs(dy)>5)moved=true;
      var newLeft=startLeft+dx,newTop=startTop+dy;
      var maxX=window.innerWidth-btn.offsetWidth;
      var maxY=window.innerHeight-btn.offsetHeight;
      newLeft=Math.max(0,Math.min(newLeft,maxX));
      newTop=Math.max(0,Math.min(newTop,maxY));
      btn.style.left=newLeft+'px';
      btn.style.top=newTop+'px';
      btn.style.right='auto';
      btn.style.bottom='auto';
      e.preventDefault();
    }
    function onEnd(){
      isDrag=false;
      btn.style.transition='left 0.2s';
      var rect=btn.getBoundingClientRect();
      var midX=rect.left+rect.width/2;
      if(midX<window.innerWidth/2){
        btn.style.left='16px';btn.style.right='auto';
      }else{
        btn.style.left=(window.innerWidth-btn.offsetWidth-16)+'px';btn.style.right='auto';
      }
      if(!moved){
        window.open('https://wa.me/905419070194?text=Merhaba%2C%20MasalSensin%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum','_blank');
      }
    }
    btn.addEventListener('touchstart',onStart,{passive:false});
    btn.addEventListener('touchmove',onMove,{passive:false});
    btn.addEventListener('touchend',onEnd);
    btn.addEventListener('mousedown',onStart);
    document.addEventListener('mousemove',onMove);
    document.addEventListener('mouseup',function(){if(isDrag)onEnd()});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
   10. Desktop density + micro-animation suite (desktop only, min-width 990px)
   ========================================================================== */
(function(){
  // Guard: only run on desktop
  var isDesktop = function(){ return window.matchMedia('(min-width: 990px)').matches; };
  if (!isDesktop()) return;
  // Respect reduced motion
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- 7. Scroll reveal: NARROW safe set only ---
     Limited to sections we fully control. Broad theme selectors
     (.shopify-section, .esv-section, .section--page-width) break
     product carousels that have their own opacity animations. */
  function initScrollReveal(){
    if (reduceMotion) return;
    var targets = [
      '.ms-bento',
      '.ms-product-trust-strip',
      '.ms-product-feature-list'
    ];
    targets.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        if (!el.classList.contains('ms-reveal')) el.classList.add('ms-reveal');
      });
    });
    // Observe ALL .ms-reveal elements (including any pre-tagged by DOM injection)
    var els = [].slice.call(document.querySelectorAll('.ms-reveal'));
    if (!('IntersectionObserver' in window)) {
      els.forEach(function(el){ el.classList.add('ms-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) {
          e.target.classList.add('ms-revealed');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el){ io.observe(el); });
    // Fallback: any element still unrevealed after 3s gets revealed (safety)
    setTimeout(function(){
      document.querySelectorAll('.ms-reveal:not(.ms-revealed)').forEach(function(el){
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('ms-revealed');
      });
    }, 1500);
  }

  /* --- 6. Number counter: animate [data-ms-count] elements when visible --- */
  function initCounters(){
    if (reduceMotion) return;
    var counters = document.querySelectorAll('[data-ms-count]');
    if (!counters.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        var el = e.target;
        var target = parseInt(el.getAttribute('data-ms-count'), 10) || 0;
        var prefix = el.getAttribute('data-ms-prefix') || '';
        var suffix = el.getAttribute('data-ms-suffix') || '';
        var duration = 1400;
        var start = performance.now();
        var frame = function(now){
          var p = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = Math.round(target * eased);
          el.textContent = prefix + val.toLocaleString('tr-TR') + suffix;
          if (p < 1) requestAnimationFrame(frame);
        };
        requestAnimationFrame(frame);
        io.unobserve(el);
      });
    }, { threshold: 0.4 });
    counters.forEach(function(el){ io.observe(el); });
  }

  /* --- 8. Hero typewriter on subtitle (runs once per session) --- */
  function initTypewriter(){
    if (reduceMotion) return;
    try { if (sessionStorage.getItem('ms_typed') === '1') return; } catch(e){}
    // Find hero subtitle candidate (below main hero heading)
    var heroWrap = document.querySelector('.hero, [class*="hero__container"], .image-banner');
    if (!heroWrap) return;
    // Look for a subtitle-like element
    var sub = heroWrap.querySelector('[data-ms-type], .hero__subtitle, .hero-sub, .banner__text');
    if (!sub) {
      // Fallback: try h2/h3 inside hero that looks like subtitle
      sub = [...heroWrap.querySelectorAll('p, h2, h3')].find(function(e){
        var t = e.textContent.trim();
        return t && t.length > 10 && t.length < 120 && !/HAYATIMDA|HEDİYE/i.test(t);
      });
    }
    if (!sub) return;
    var full = sub.textContent.trim();
    if (!full) return;
    sub.textContent = '';
    sub.classList.add('ms-type-caret');
    var i = 0;
    var speed = 40;
    var step = function(){
      if (i <= full.length) {
        sub.textContent = full.slice(0, i);
        i++;
        setTimeout(step, speed);
      } else {
        setTimeout(function(){ sub.classList.remove('ms-type-caret'); }, 1200);
        try { sessionStorage.setItem('ms_typed', '1'); } catch(e){}
      }
    };
    setTimeout(step, 400);
  }

  /* --- 2. Inject product page trust strip + feature list ---
     Append AFTER the sticky media column (as sibling) so it becomes part of
     the normal page flow and breaks out of the sticky container. Also remove
     sticky behavior from media on desktop since the column is now shorter. */
  function initProductEnhancements(){
    var media = document.querySelector('.product-information__media');
    if (!media) return;
    if (document.querySelector('.ms-product-trust-strip')) return;

    var strip = document.createElement('div');
    strip.className = 'ms-product-trust-strip';
    strip.innerHTML =
      '<div class="ms-pt-item">' +
        '<span class="ms-pt-num"><span data-ms-count="1200" data-ms-suffix="+">1.200+</span></span>' +
        '<span class="ms-pt-label">Mutlu Aile</span>' +
      '</div>' +
      '<div class="ms-pt-item">' +
        '<span class="ms-pt-num">4.9<span style="font-size:18px;color:#F4A261;"> ★</span></span>' +
        '<span class="ms-pt-label">Ortalama Puan</span>' +
      '</div>' +
      '<div class="ms-pt-item">' +
        '<span class="ms-pt-num">3-7 <span style="font-size:14px;">Gün</span></span>' +
        '<span class="ms-pt-label">Kapında</span>' +
      '</div>';

    var features = document.createElement('div');
    features.className = 'ms-product-feature-list';
    features.innerHTML =
      '<div class="ms-pfl-title">Bu Kitaba Dahil Olanlar</div>' +
      '<ul class="ms-pfl-list">' +
        '<li>Çocuğun adı hikayenin içinde 40+ kez geçer</li>' +
        '<li>24-36 sayfa premium kuşe kağıda baskı, sert kapak</li>' +
        '<li>Kahraman karakterin yaş ve cinsiyetine özel tasarım</li>' +
        '<li>Özel hediye kutusu + ithaf kartı ücretsiz</li>' +
        '<li>Ekibimizin hazırladığı benzersiz bir hikaye</li>' +
      '</ul>';

    // Wrap strip + features in a container that sits in the media column
    var wrap = document.createElement('div');
    wrap.className = 'ms-product-media-extras';
    wrap.appendChild(strip);
    wrap.appendChild(features);

    // Release sticky from media so the column can grow with extras
    media.classList.remove('ms-gallery-sticky');
    media.style.position = 'static';
    media.appendChild(wrap);
  }

  /* --- 3. Homepage bento "Neden MasalSensin?" injected section --- */
  function initHomepageBento(){
    // only on homepage
    if (!/^\/?(\?|$)/.test(location.pathname) && location.pathname !== '/') return;
    if (document.querySelector('.ms-bento')) return;

    // Find an insertion point: after en-sevilenler or before videolarımız
    var anchor = document.querySelector('[id*="en_sevilenler_carousel"]') ||
                 document.querySelector('[id*="mutlu_aileler"]') ||
                 document.querySelector('[id*="video_carousel"]');
    if (!anchor) return;

    var bento = document.createElement('section');
    bento.className = 'ms-bento ms-reveal';
    // Each bento card wrapped in <a> so clicking anywhere leads somewhere relevant.
    bento.innerHTML =
      '<div class="ms-bento-wrap">' +
        '<div class="ms-bento-head">' +
          '<span class="ms-bento-eyebrow">Neden MasalSensin?</span>' +
          '<h2 class="ms-bento-title">Bir hediyeden çok daha fazlası</h2>' +
          '<p class="ms-bento-sub">Her sayfasında çocuğun adı, hikayenin içinde kendisi. Yıllarca sakladığı bir hatıra.</p>' +
        '</div>' +
        '<div class="ms-bento-grid">' +
          '<a href="/pages/hediye-secici" class="ms-bento-card ms-bento-card--hero" style="text-decoration:none;">' +
            '<div class="ms-bento-card-label">★ En çok sevilen</div>' +
            '<div class="ms-bento-card-big">Çocuğun, kendi masalının kahramanı</div>' +
            '<div class="ms-bento-card-small">Adı, yaşı, saçları, arkadaşları — hepsi hikayenin içinde.</div>' +
          '</a>' +
          '<a href="/collections/frontpage" class="ms-bento-card ms-bento-card--stat" style="text-decoration:none;">' +
            '<div class="ms-bento-stat-num" data-ms-count="1200" data-ms-suffix="+">1.200+</div>' +
            '<div class="ms-bento-stat-label">Mutlu Aile</div>' +
          '</a>' +
          '<a href="/collections/frontpage" class="ms-bento-card ms-bento-card--quote" style="text-decoration:none;">' +
            '<div class="ms-bento-quote">"Oğlum her gece aynı sayfayı açıp adını buluyor — kitap artık en sevdiği oyuncağı."</div>' +
            '<div class="ms-bento-quote-by">— Ayşe, İstanbul</div>' +
          '</a>' +
          '<a href="/pages/hakkimizda" class="ms-bento-card ms-bento-card--feat" style="text-decoration:none;">' +
            '<div class="ms-bento-feat-icon">✒️</div>' +
            '<div class="ms-bento-feat-title">Elde tasarlanır</div>' +
            '<div class="ms-bento-feat-sub">AI değil — ekibimiz her hikayeyi titizlikle hazırlar.</div>' +
          '</a>' +
          '<a href="/collections/frontpage" class="ms-bento-card ms-bento-card--stat ms-bento-card--stat-gold" style="text-decoration:none;">' +
            '<div class="ms-bento-stat-num">4.9<span style="font-size:28px;color:#F4A261;margin-left:4px;">★</span></div>' +
            '<div class="ms-bento-stat-label">Ortalama Puan</div>' +
          '</a>' +
          '<a href="/pages/hediye-secici" class="ms-bento-card ms-bento-card--feat" style="text-decoration:none;">' +
            '<div class="ms-bento-feat-icon">📦</div>' +
            '<div class="ms-bento-feat-title">Özel hediye kutusu</div>' +
            '<div class="ms-bento-feat-sub">İthaf kartıyla birlikte, armağan için hazır.</div>' +
          '</a>' +
        '</div>' +
      '</div>';

    anchor.parentNode.insertBefore(bento, anchor);
  }

  function init(){
    // DOM injection MUST run before scroll-reveal observer queries the targets
    initProductEnhancements();
    initHomepageBento();
    // Now observe — includes newly-injected nodes
    initScrollReveal();
    initCounters();
    initTypewriter();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
   Empty cart — AI-generated illustration swap
   Replaces the default emoji/SVG with the Gemini-generated PNG.
   Runs on both mobile and desktop.
   ========================================================================== */
(function(){
  var ILLUSTRATION_URL = 'https://cdn.shopify.com/s/files/1/0814/5669/3473/t/7/assets/ms-empty-cart.png?v=1775926467';

  function init(){
    var visual = document.querySelector('.ms-empty-cart .ms-empty-cart-visual');
    if (!visual) return;
    if (visual.querySelector('.ms-empty-illustration')) return;
    // Replace contents with img
    visual.innerHTML = '<img class="ms-empty-illustration" src="' + ILLUSTRATION_URL +
      '" alt="Masalını bekleyen çocuk" width="200" height="200" loading="eager" decoding="async">';
    visual.classList.add('ms-empty-cart-visual--illus');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
   Mobile hero swap — replace homepage hero with AI-generated banner on mobile
   Banner already contains headline/subhead/CTA baked into the image.
   ========================================================================== */
(function(){
  var CTA_LINK = '/pages/hediye-secici';
  var SLIDES = [
    { url: 'https://cdn.shopify.com/s/files/1/0814/5669/3473/t/7/assets/ms-slide-1.png?v=1775986833', alt: 'Kendi masalının içinde yaşıyor' },
    { url: 'https://cdn.shopify.com/s/files/1/0814/5669/3473/t/7/assets/ms-slide-2.png?v=1775986835', alt: 'Bu Masalın Kahramanı O!' },
    { url: 'https://cdn.shopify.com/s/files/1/0814/5669/3473/t/7/assets/ms-slide-3.png?v=1775986838', alt: 'Açıldığı an büyü başlar' }
  ];
  function init(){
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    if (!/^\/?(\?|$)/.test(location.pathname) && location.pathname !== '/') return;
    var hero = document.querySelector('.hero');
    if (!hero) return;
    if (hero.dataset.msSwapped === '1') return;
    hero.dataset.msSwapped = '1';
    // Build slider HTML
    var slidesHTML = SLIDES.map(function(s, i){
      return '<div class="ms-hero-slide' + (i === 0 ? ' ms-hero-slide--active' : '') + '">' +
        '<a href="' + CTA_LINK + '" aria-label="' + s.alt + '">' +
          '<img src="' + s.url + '" alt="' + s.alt + '" width="390" height="488" loading="' + (i === 0 ? 'eager' : 'lazy') + '" decoding="async">' +
        '</a></div>';
    }).join('');
    var dotsHTML = SLIDES.map(function(_, i){
      return '<button class="ms-hero-dot' + (i === 0 ? ' ms-hero-dot--active' : '') + '" data-slide="' + i + '" aria-label="Slide ' + (i+1) + '"></button>';
    }).join('');
    hero.innerHTML =
      '<div class="ms-hero-slider">' +
        '<div class="ms-hero-track">' + slidesHTML + '</div>' +
        '<div class="ms-hero-dots">' + dotsHTML + '</div>' +
      '</div>';
    hero.classList.add('ms-hero-swapped');
    // Slider logic
    var current = 0;
    var track = hero.querySelector('.ms-hero-track');
    var dots = hero.querySelectorAll('.ms-hero-dot');
    var slideEls = hero.querySelectorAll('.ms-hero-slide');
    function goTo(idx){
      current = idx;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      slideEls.forEach(function(s, i){ s.classList.toggle('ms-hero-slide--active', i === idx); });
      dots.forEach(function(d, i){ d.classList.toggle('ms-hero-dot--active', i === idx); });
    }
    dots.forEach(function(d){ d.addEventListener('click', function(){ goTo(parseInt(d.dataset.slide)); }); });
    // Auto-advance every 5s
    var autoTimer = setInterval(function(){ goTo((current + 1) % SLIDES.length); }, 5000);
    // Swipe support
    var startX = 0;
    track.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; clearInterval(autoTimer); }, { passive: true });
    track.addEventListener('touchend', function(e){
      var diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 50) goTo(diff > 0 ? Math.max(0, current - 1) : Math.min(SLIDES.length - 1, current + 1));
      autoTimer = setInterval(function(){ goTo((current + 1) % SLIDES.length); }, 5000);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
